export default {
  namespaced: true,
  state: () => ({
    progressList:[]
  }),
  mutations: {
    SET_PROGRESS_LIST(state,value){
      state.progressList=value
    },
  },
  actions: {
    setProgressList({commit},value){
      commit('SET_PROGRESS_LIST',value)
    },
  }
}
